module.exports = __webpack_public_path__ + "static/media/contact-icon.1a660cba.svg";